import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { ReactNode } from "react";

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwic2x1ZyI6ImZyZWUtaG9tZS10cmlhbCIsImFkbWluIjp0cnVlLCJpYXQiOjE1MTYyMzkwMjIsImV4cCI6MTc3NjE1MTQ3Nn0.Lv0im5CTj0cX-GxaHtBQZPBlRNYx8SbjdUGEa5ZtR68",
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message }) => {
      console.error(message);
      if (message === "Unauthorized") {
        localStorage.removeItem("token");
      }
    });
  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

export function createClient(httpLink: HttpLink): ApolloClient<any> {
  const links: ApolloLink[] = [httpLink].filter(
    (r) => r !== undefined,
  ) as ApolloLink[];

  return new ApolloClient({
    link: ApolloLink.from([authLink, errorLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "cache-and-network",
        errorPolicy: "ignore",
      },
      query: {
        fetchPolicy: "no-cache",
        errorPolicy: "all",
      },
    },
  });
}

export function GraphQLProvider({
  children,
  endpoint,
}: {
  children: ReactNode;
  endpoint: string;
}) {
  const httpLink = new HttpLink({
    uri: endpoint,
  });
  return (
    <ApolloProvider client={createClient(httpLink)}>{children}</ApolloProvider>
  );
}
